






























































































import { defineComponent, reactive, ref } from '@vue/composition-api';
import OlbButton from '../../button';
import OlbDatepicker from '../../datepicker';
import OlbIcon from '../../icon';
import OlbLoader from '../../loader';
import OlbInput from '../elements/input/Input.vue';
import OlbFlyoutSelect from '../elements/select/FlyoutSelect.vue';
import { fetchLabel } from '../fetchLabel';
import OlbForm from '../form.vue';
import { formProps } from '../formUtils';
import { LabeledListItem } from '../types';

export default defineComponent({
	components: {
		OlbForm,
		OlbInput,
		OlbDatepicker,
		OlbFlyoutSelect,
		OlbButton,
		OlbIcon,
		OlbLoader,
	},
	props: {
		...formProps,
	},
	setup() {
		const formData = reactive({
			account: '',
			salutation: '',
			firstName: '',
			lastName: '',
			birthDate: '',
			email: '',
			phone: '+49',
			legal: false,
		});
		const salutationOptions = ref<LabeledListItem[]>([]);
		fetchLabel('Salutation').then((data) => {
			salutationOptions.value = Object.entries(data as { [key: string]: string }).map((item: string[]) => {
				return {
					label: item[1],
					value: item[0],
				};
			});
		});
		const initFormData = { ...formData };
		function resetForm() {
			Object.assign(formData, initFormData);
		}
		return {
			formData,
			salutationOptions,
			resetForm,
		};
	},
});
